// source: positionHistoryMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf')
var goog = jspb
var global = Function('return this')()

goog.exportSymbol('proto.PositionHistoryPbMsg', null, global)
goog.exportSymbol('proto.PositionHistoryPbMsg.CurrencyPair', null, global)
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PositionHistoryPbMsg = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.PositionHistoryPbMsg, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PositionHistoryPbMsg.displayName = 'proto.PositionHistoryPbMsg'
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PositionHistoryPbMsg.CurrencyPair = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null)
}
goog.inherits(proto.PositionHistoryPbMsg.CurrencyPair, jspb.Message)
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PositionHistoryPbMsg.CurrencyPair.displayName = 'proto.PositionHistoryPbMsg.CurrencyPair'
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PositionHistoryPbMsg.prototype.toObject = function (opt_includeInstance) {
    return proto.PositionHistoryPbMsg.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PositionHistoryPbMsg} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PositionHistoryPbMsg.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        userid: jspb.Message.getFieldWithDefault(msg, 2, 0),
        openprice: jspb.Message.getFieldWithDefault(msg, 3, ''),
        closeprice: jspb.Message.getFieldWithDefault(msg, 4, ''),
        realizedsurplus: jspb.Message.getFieldWithDefault(msg, 5, ''),
        openmargin: jspb.Message.getFieldWithDefault(msg, 6, ''),
        totalamount: jspb.Message.getFieldWithDefault(msg, 7, ''),
        closeamount: jspb.Message.getFieldWithDefault(msg, 8, ''),
        maxamount: jspb.Message.getFieldWithDefault(msg, 9, ''),
        opendate: jspb.Message.getFieldWithDefault(msg, 10, 0),
        closealldate: jspb.Message.getFieldWithDefault(msg, 11, 0),
        contractcode: jspb.Message.getFieldWithDefault(msg, 12, ''),
        detailside: jspb.Message.getFieldWithDefault(msg, 13, ''),
        dualposition: jspb.Message.getFieldWithDefault(msg, 14, 0),
        dealmarket: jspb.Message.getFieldWithDefault(msg, 15, 0),
        lever: jspb.Message.getFieldWithDefault(msg, 16, 0),
        positiontype: jspb.Message.getFieldWithDefault(msg, 17, 0),
        status: jspb.Message.getFieldWithDefault(msg, 18, 0),
        positionid: jspb.Message.getFieldWithDefault(msg, 19, 0),
        env: jspb.Message.getFieldWithDefault(msg, 20, 0),
        basecontractcode: jspb.Message.getFieldWithDefault(msg, 21, ''),
        contractliquidatedate: jspb.Message.getFieldWithDefault(msg, 22, 0),
        brokerid: jspb.Message.getFieldWithDefault(msg, 23, 0),
        closeprofit: jspb.Message.getFieldWithDefault(msg, 24, ''),
        fundrateprofit: jspb.Message.getFieldWithDefault(msg, 25, ''),
        fee: jspb.Message.getFieldWithDefault(msg, 26, ''),
        deliveringprofit: jspb.Message.getFieldWithDefault(msg, 27, ''),
        selectedmode: jspb.Message.getFieldWithDefault(msg, 28, 0),
        biztype: jspb.Message.getFieldWithDefault(msg, 29, ''),
        contracttype: jspb.Message.getFieldWithDefault(msg, 30, ''),
        liquidationdate: jspb.Message.getFieldWithDefault(msg, 31, 0),
        currencypair:
          (f = msg.getCurrencypair()) && proto.PositionHistoryPbMsg.CurrencyPair.toObject(includeInstance, f),
        donationfee: jspb.Message.getFieldWithDefault(msg, 33, ''),
        donationcloseprofit: jspb.Message.getFieldWithDefault(msg, 34, ''),
        donationfundrateprofit: jspb.Message.getFieldWithDefault(msg, 35, ''),
        donationopenmargin: jspb.Message.getFieldWithDefault(msg, 36, ''),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PositionHistoryPbMsg}
 */
proto.PositionHistoryPbMsg.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.PositionHistoryPbMsg()
  return proto.PositionHistoryPbMsg.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PositionHistoryPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PositionHistoryPbMsg}
 */
proto.PositionHistoryPbMsg.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setId(value)
        break
      case 2:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setUserid(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenprice(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setCloseprice(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setRealizedsurplus(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setOpenmargin(value)
        break
      case 7:
        var value = /** @type {string} */ (reader.readString())
        msg.setTotalamount(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setCloseamount(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaxamount(value)
        break
      case 10:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setOpendate(value)
        break
      case 11:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setClosealldate(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setContractcode(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setDetailside(value)
        break
      case 14:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDualposition(value)
        break
      case 15:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDealmarket(value)
        break
      case 16:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setLever(value)
        break
      case 17:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setPositiontype(value)
        break
      case 18:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setStatus(value)
        break
      case 19:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setPositionid(value)
        break
      case 20:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setEnv(value)
        break
      case 21:
        var value = /** @type {string} */ (reader.readString())
        msg.setBasecontractcode(value)
        break
      case 22:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setContractliquidatedate(value)
        break
      case 23:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setBrokerid(value)
        break
      case 24:
        var value = /** @type {string} */ (reader.readString())
        msg.setCloseprofit(value)
        break
      case 25:
        var value = /** @type {string} */ (reader.readString())
        msg.setFundrateprofit(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setFee(value)
        break
      case 27:
        var value = /** @type {string} */ (reader.readString())
        msg.setDeliveringprofit(value)
        break
      case 28:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSelectedmode(value)
        break
      case 29:
        var value = /** @type {string} */ (reader.readString())
        msg.setBiztype(value)
        break
      case 30:
        var value = /** @type {string} */ (reader.readString())
        msg.setContracttype(value)
        break
      case 31:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setLiquidationdate(value)
        break
      case 32:
        var value = new proto.PositionHistoryPbMsg.CurrencyPair()
        reader.readMessage(value, proto.PositionHistoryPbMsg.CurrencyPair.deserializeBinaryFromReader)
        msg.setCurrencypair(value)
        break
      case 33:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationfee(value)
        break
      case 34:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationcloseprofit(value)
        break
      case 35:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationfundrateprofit(value)
        break
      case 36:
        var value = /** @type {string} */ (reader.readString())
        msg.setDonationopenmargin(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PositionHistoryPbMsg.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.PositionHistoryPbMsg.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PositionHistoryPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PositionHistoryPbMsg.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getId()
  if (f !== 0) {
    writer.writeInt64(1, f)
  }
  f = message.getUserid()
  if (f !== 0) {
    writer.writeInt64(2, f)
  }
  f = message.getOpenprice()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getCloseprice()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getRealizedsurplus()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getOpenmargin()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getTotalamount()
  if (f.length > 0) {
    writer.writeString(7, f)
  }
  f = message.getCloseamount()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getMaxamount()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getOpendate()
  if (f !== 0) {
    writer.writeInt64(10, f)
  }
  f = message.getClosealldate()
  if (f !== 0) {
    writer.writeInt64(11, f)
  }
  f = message.getContractcode()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getDetailside()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getDualposition()
  if (f !== 0) {
    writer.writeInt32(14, f)
  }
  f = message.getDealmarket()
  if (f !== 0) {
    writer.writeInt32(15, f)
  }
  f = message.getLever()
  if (f !== 0) {
    writer.writeInt32(16, f)
  }
  f = message.getPositiontype()
  if (f !== 0) {
    writer.writeInt32(17, f)
  }
  f = message.getStatus()
  if (f !== 0) {
    writer.writeInt32(18, f)
  }
  f = message.getPositionid()
  if (f !== 0) {
    writer.writeInt64(19, f)
  }
  f = message.getEnv()
  if (f !== 0) {
    writer.writeInt32(20, f)
  }
  f = message.getBasecontractcode()
  if (f.length > 0) {
    writer.writeString(21, f)
  }
  f = message.getContractliquidatedate()
  if (f !== 0) {
    writer.writeInt64(22, f)
  }
  f = message.getBrokerid()
  if (f !== 0) {
    writer.writeInt32(23, f)
  }
  f = message.getCloseprofit()
  if (f.length > 0) {
    writer.writeString(24, f)
  }
  f = message.getFundrateprofit()
  if (f.length > 0) {
    writer.writeString(25, f)
  }
  f = message.getFee()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getDeliveringprofit()
  if (f.length > 0) {
    writer.writeString(27, f)
  }
  f = message.getSelectedmode()
  if (f !== 0) {
    writer.writeInt32(28, f)
  }
  f = message.getBiztype()
  if (f.length > 0) {
    writer.writeString(29, f)
  }
  f = message.getContracttype()
  if (f.length > 0) {
    writer.writeString(30, f)
  }
  f = message.getLiquidationdate()
  if (f !== 0) {
    writer.writeInt64(31, f)
  }
  f = message.getCurrencypair()
  if (f != null) {
    writer.writeMessage(32, f, proto.PositionHistoryPbMsg.CurrencyPair.serializeBinaryToWriter)
  }
  f = message.getDonationfee()
  if (f.length > 0) {
    writer.writeString(33, f)
  }
  f = message.getDonationcloseprofit()
  if (f.length > 0) {
    writer.writeString(34, f)
  }
  f = message.getDonationfundrateprofit()
  if (f.length > 0) {
    writer.writeString(35, f)
  }
  f = message.getDonationopenmargin()
  if (f.length > 0) {
    writer.writeString(36, f)
  }
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.PositionHistoryPbMsg.CurrencyPair.prototype.toObject = function (opt_includeInstance) {
    return proto.PositionHistoryPbMsg.CurrencyPair.toObject(opt_includeInstance, this)
  }

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.PositionHistoryPbMsg.CurrencyPair} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.PositionHistoryPbMsg.CurrencyPair.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        id: jspb.Message.getFieldWithDefault(msg, 1, 0),
        biz: jspb.Message.getFieldWithDefault(msg, 2, ''),
        indexbase: jspb.Message.getFieldWithDefault(msg, 3, ''),
        base: jspb.Message.getFieldWithDefault(msg, 4, ''),
        quote: jspb.Message.getFieldWithDefault(msg, 5, ''),
        quotedisplayname: jspb.Message.getFieldWithDefault(msg, 6, ''),
        basedisplayname: jspb.Message.getFieldWithDefault(msg, 7, ''),
        indexbasedisplayname: jspb.Message.getFieldWithDefault(msg, 8, ''),
        paircode: jspb.Message.getFieldWithDefault(msg, 9, ''),
        insuranceaccount: jspb.Message.getFieldWithDefault(msg, 10, 0),
        mintradeunit: jspb.Message.getFieldWithDefault(msg, 11, ''),
        unitamount: jspb.Message.getFieldWithDefault(msg, 12, ''),
        minorderamount: jspb.Message.getFieldWithDefault(msg, 13, ''),
        maxorderamount: jspb.Message.getFieldWithDefault(msg, 14, ''),
        maxorders: jspb.Message.getFieldWithDefault(msg, 15, 0),
        mintradedigit: jspb.Message.getFieldWithDefault(msg, 16, 0),
        minquotedigit: jspb.Message.getFieldWithDefault(msg, 17, 0),
        maxlevel: jspb.Message.getFieldWithDefault(msg, 18, ''),
        type: jspb.Message.getFieldWithDefault(msg, 19, 0),
        preliqudatepricethreshold: jspb.Message.getFieldWithDefault(msg, 20, ''),
        premiumminrange: jspb.Message.getFieldWithDefault(msg, 21, ''),
        premiummaxrange: jspb.Message.getFieldWithDefault(msg, 22, ''),
        premiumdepth: jspb.Message.getFieldWithDefault(msg, 23, ''),
        fundingceiling: jspb.Message.getFieldWithDefault(msg, 24, ''),
        minamount: jspb.Message.getFieldWithDefault(msg, 25, ''),
        diffamount: jspb.Message.getFieldWithDefault(msg, 26, ''),
        maxamount: jspb.Message.getFieldWithDefault(msg, 27, ''),
        maintainrate: jspb.Message.getFieldWithDefault(msg, 28, ''),
        liquidationhour: jspb.Message.getFieldWithDefault(msg, 29, 0),
        dkfee: jspb.Message.getFieldWithDefault(msg, 30, 0),
        env: jspb.Message.getFieldWithDefault(msg, 31, 0),
        online: jspb.Message.getFieldWithDefault(msg, 32, 0),
        direction: jspb.Message.getFieldWithDefault(msg, 33, 0),
        interestrate: jspb.Message.getFieldWithDefault(msg, 34, ''),
        createddate: jspb.Message.getFieldWithDefault(msg, 35, 0),
        modifydate: jspb.Message.getFieldWithDefault(msg, 36, 0),
        marketpricedigit: jspb.Message.getFieldWithDefault(msg, 37, 0),
        margindigit: jspb.Message.getFieldWithDefault(msg, 38, 0),
        positionriskremind: jspb.Message.getFieldWithDefault(msg, 39, 0),
        sort: jspb.Message.getFieldWithDefault(msg, 40, 0),
        opentradetime: jspb.Message.getFieldWithDefault(msg, 41, 0),
        feeaccount: jspb.Message.getFieldWithDefault(msg, 42, 0),
      }

    if (includeInstance) {
      obj.$jspbMessageInstance = msg
    }
    return obj
  }
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair}
 */
proto.PositionHistoryPbMsg.CurrencyPair.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes)
  var msg = new proto.PositionHistoryPbMsg.CurrencyPair()
  return proto.PositionHistoryPbMsg.CurrencyPair.deserializeBinaryFromReader(msg, reader)
}

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PositionHistoryPbMsg.CurrencyPair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair}
 */
proto.PositionHistoryPbMsg.CurrencyPair.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break
    }
    var field = reader.getFieldNumber()
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setId(value)
        break
      case 2:
        var value = /** @type {string} */ (reader.readString())
        msg.setBiz(value)
        break
      case 3:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbase(value)
        break
      case 4:
        var value = /** @type {string} */ (reader.readString())
        msg.setBase(value)
        break
      case 5:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuote(value)
        break
      case 6:
        var value = /** @type {string} */ (reader.readString())
        msg.setQuotedisplayname(value)
        break
      case 7:
        var value = /** @type {string} */ (reader.readString())
        msg.setBasedisplayname(value)
        break
      case 8:
        var value = /** @type {string} */ (reader.readString())
        msg.setIndexbasedisplayname(value)
        break
      case 9:
        var value = /** @type {string} */ (reader.readString())
        msg.setPaircode(value)
        break
      case 10:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setInsuranceaccount(value)
        break
      case 11:
        var value = /** @type {string} */ (reader.readString())
        msg.setMintradeunit(value)
        break
      case 12:
        var value = /** @type {string} */ (reader.readString())
        msg.setUnitamount(value)
        break
      case 13:
        var value = /** @type {string} */ (reader.readString())
        msg.setMinorderamount(value)
        break
      case 14:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaxorderamount(value)
        break
      case 15:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMaxorders(value)
        break
      case 16:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMintradedigit(value)
        break
      case 17:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMinquotedigit(value)
        break
      case 18:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaxlevel(value)
        break
      case 19:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setType(value)
        break
      case 20:
        var value = /** @type {string} */ (reader.readString())
        msg.setPreliqudatepricethreshold(value)
        break
      case 21:
        var value = /** @type {string} */ (reader.readString())
        msg.setPremiumminrange(value)
        break
      case 22:
        var value = /** @type {string} */ (reader.readString())
        msg.setPremiummaxrange(value)
        break
      case 23:
        var value = /** @type {string} */ (reader.readString())
        msg.setPremiumdepth(value)
        break
      case 24:
        var value = /** @type {string} */ (reader.readString())
        msg.setFundingceiling(value)
        break
      case 25:
        var value = /** @type {string} */ (reader.readString())
        msg.setMinamount(value)
        break
      case 26:
        var value = /** @type {string} */ (reader.readString())
        msg.setDiffamount(value)
        break
      case 27:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaxamount(value)
        break
      case 28:
        var value = /** @type {string} */ (reader.readString())
        msg.setMaintainrate(value)
        break
      case 29:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setLiquidationhour(value)
        break
      case 30:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDkfee(value)
        break
      case 31:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setEnv(value)
        break
      case 32:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setOnline(value)
        break
      case 33:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setDirection(value)
        break
      case 34:
        var value = /** @type {string} */ (reader.readString())
        msg.setInterestrate(value)
        break
      case 35:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setCreateddate(value)
        break
      case 36:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setModifydate(value)
        break
      case 37:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMarketpricedigit(value)
        break
      case 38:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setMargindigit(value)
        break
      case 39:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setPositionriskremind(value)
        break
      case 40:
        var value = /** @type {number} */ (reader.readInt32())
        msg.setSort(value)
        break
      case 41:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setOpentradetime(value)
        break
      case 42:
        var value = /** @type {number} */ (reader.readInt64())
        msg.setFeeaccount(value)
        break
      default:
        reader.skipField()
        break
    }
  }
  return msg
}

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter()
  proto.PositionHistoryPbMsg.CurrencyPair.serializeBinaryToWriter(this, writer)
  return writer.getResultBuffer()
}

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PositionHistoryPbMsg.CurrencyPair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PositionHistoryPbMsg.CurrencyPair.serializeBinaryToWriter = function (message, writer) {
  var f = undefined
  f = message.getId()
  if (f !== 0) {
    writer.writeInt32(1, f)
  }
  f = message.getBiz()
  if (f.length > 0) {
    writer.writeString(2, f)
  }
  f = message.getIndexbase()
  if (f.length > 0) {
    writer.writeString(3, f)
  }
  f = message.getBase()
  if (f.length > 0) {
    writer.writeString(4, f)
  }
  f = message.getQuote()
  if (f.length > 0) {
    writer.writeString(5, f)
  }
  f = message.getQuotedisplayname()
  if (f.length > 0) {
    writer.writeString(6, f)
  }
  f = message.getBasedisplayname()
  if (f.length > 0) {
    writer.writeString(7, f)
  }
  f = message.getIndexbasedisplayname()
  if (f.length > 0) {
    writer.writeString(8, f)
  }
  f = message.getPaircode()
  if (f.length > 0) {
    writer.writeString(9, f)
  }
  f = message.getInsuranceaccount()
  if (f !== 0) {
    writer.writeInt64(10, f)
  }
  f = message.getMintradeunit()
  if (f.length > 0) {
    writer.writeString(11, f)
  }
  f = message.getUnitamount()
  if (f.length > 0) {
    writer.writeString(12, f)
  }
  f = message.getMinorderamount()
  if (f.length > 0) {
    writer.writeString(13, f)
  }
  f = message.getMaxorderamount()
  if (f.length > 0) {
    writer.writeString(14, f)
  }
  f = message.getMaxorders()
  if (f !== 0) {
    writer.writeInt32(15, f)
  }
  f = message.getMintradedigit()
  if (f !== 0) {
    writer.writeInt32(16, f)
  }
  f = message.getMinquotedigit()
  if (f !== 0) {
    writer.writeInt32(17, f)
  }
  f = message.getMaxlevel()
  if (f.length > 0) {
    writer.writeString(18, f)
  }
  f = message.getType()
  if (f !== 0) {
    writer.writeInt64(19, f)
  }
  f = message.getPreliqudatepricethreshold()
  if (f.length > 0) {
    writer.writeString(20, f)
  }
  f = message.getPremiumminrange()
  if (f.length > 0) {
    writer.writeString(21, f)
  }
  f = message.getPremiummaxrange()
  if (f.length > 0) {
    writer.writeString(22, f)
  }
  f = message.getPremiumdepth()
  if (f.length > 0) {
    writer.writeString(23, f)
  }
  f = message.getFundingceiling()
  if (f.length > 0) {
    writer.writeString(24, f)
  }
  f = message.getMinamount()
  if (f.length > 0) {
    writer.writeString(25, f)
  }
  f = message.getDiffamount()
  if (f.length > 0) {
    writer.writeString(26, f)
  }
  f = message.getMaxamount()
  if (f.length > 0) {
    writer.writeString(27, f)
  }
  f = message.getMaintainrate()
  if (f.length > 0) {
    writer.writeString(28, f)
  }
  f = message.getLiquidationhour()
  if (f !== 0) {
    writer.writeInt32(29, f)
  }
  f = message.getDkfee()
  if (f !== 0) {
    writer.writeInt32(30, f)
  }
  f = message.getEnv()
  if (f !== 0) {
    writer.writeInt32(31, f)
  }
  f = message.getOnline()
  if (f !== 0) {
    writer.writeInt32(32, f)
  }
  f = message.getDirection()
  if (f !== 0) {
    writer.writeInt32(33, f)
  }
  f = message.getInterestrate()
  if (f.length > 0) {
    writer.writeString(34, f)
  }
  f = message.getCreateddate()
  if (f !== 0) {
    writer.writeInt64(35, f)
  }
  f = message.getModifydate()
  if (f !== 0) {
    writer.writeInt64(36, f)
  }
  f = message.getMarketpricedigit()
  if (f !== 0) {
    writer.writeInt32(37, f)
  }
  f = message.getMargindigit()
  if (f !== 0) {
    writer.writeInt32(38, f)
  }
  f = message.getPositionriskremind()
  if (f !== 0) {
    writer.writeInt64(39, f)
  }
  f = message.getSort()
  if (f !== 0) {
    writer.writeInt32(40, f)
  }
  f = message.getOpentradetime()
  if (f !== 0) {
    writer.writeInt64(41, f)
  }
  f = message.getFeeaccount()
  if (f !== 0) {
    writer.writeInt64(42, f)
  }
}

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional string biz = 2;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getBiz = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setBiz = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value)
}

/**
 * optional string indexBase = 3;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getIndexbase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setIndexbase = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string base = 4;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getBase = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setBase = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string quote = 5;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getQuote = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setQuote = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string quoteDisplayName = 6;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getQuotedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setQuotedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional string baseDisplayName = 7;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getBasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setBasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value)
}

/**
 * optional string indexBaseDisplayName = 8;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getIndexbasedisplayname = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setIndexbasedisplayname = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string pairCode = 9;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPaircode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPaircode = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional int64 insuranceAccount = 10;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getInsuranceaccount = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setInsuranceaccount = function (value) {
  return jspb.Message.setProto3IntField(this, 10, value)
}

/**
 * optional string minTradeUnit = 11;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMintradeunit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMintradeunit = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value)
}

/**
 * optional string unitAmount = 12;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getUnitamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setUnitamount = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string minOrderAmount = 13;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMinorderamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMinorderamount = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional string maxOrderAmount = 14;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMaxorderamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMaxorderamount = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value)
}

/**
 * optional int32 maxOrders = 15;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMaxorders = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMaxorders = function (value) {
  return jspb.Message.setProto3IntField(this, 15, value)
}

/**
 * optional int32 minTradeDigit = 16;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMintradedigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMintradedigit = function (value) {
  return jspb.Message.setProto3IntField(this, 16, value)
}

/**
 * optional int32 minQuoteDigit = 17;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMinquotedigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMinquotedigit = function (value) {
  return jspb.Message.setProto3IntField(this, 17, value)
}

/**
 * optional string maxLevel = 18;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMaxlevel = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMaxlevel = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value)
}

/**
 * optional int64 type = 19;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setType = function (value) {
  return jspb.Message.setProto3IntField(this, 19, value)
}

/**
 * optional string preLiqudatePriceThreshold = 20;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPreliqudatepricethreshold = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPreliqudatepricethreshold = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value)
}

/**
 * optional string premiumMinRange = 21;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPremiumminrange = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPremiumminrange = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value)
}

/**
 * optional string premiumMaxRange = 22;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPremiummaxrange = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPremiummaxrange = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value)
}

/**
 * optional string premiumDepth = 23;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPremiumdepth = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPremiumdepth = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value)
}

/**
 * optional string fundingCeiling = 24;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getFundingceiling = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setFundingceiling = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value)
}

/**
 * optional string minAmount = 25;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMinamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMinamount = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value)
}

/**
 * optional string diffAmount = 26;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getDiffamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setDiffamount = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional string maxAmount = 27;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMaxamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMaxamount = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value)
}

/**
 * optional string maintainRate = 28;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMaintainrate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMaintainrate = function (value) {
  return jspb.Message.setProto3StringField(this, 28, value)
}

/**
 * optional int32 liquidationHour = 29;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getLiquidationhour = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setLiquidationhour = function (value) {
  return jspb.Message.setProto3IntField(this, 29, value)
}

/**
 * optional int32 dkFee = 30;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getDkfee = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setDkfee = function (value) {
  return jspb.Message.setProto3IntField(this, 30, value)
}

/**
 * optional int32 env = 31;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getEnv = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setEnv = function (value) {
  return jspb.Message.setProto3IntField(this, 31, value)
}

/**
 * optional int32 online = 32;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getOnline = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setOnline = function (value) {
  return jspb.Message.setProto3IntField(this, 32, value)
}

/**
 * optional int32 direction = 33;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getDirection = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setDirection = function (value) {
  return jspb.Message.setProto3IntField(this, 33, value)
}

/**
 * optional string interestRate = 34;
 * @return {string}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getInterestrate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setInterestrate = function (value) {
  return jspb.Message.setProto3StringField(this, 34, value)
}

/**
 * optional int64 createdDate = 35;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getCreateddate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setCreateddate = function (value) {
  return jspb.Message.setProto3IntField(this, 35, value)
}

/**
 * optional int64 modifyDate = 36;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getModifydate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setModifydate = function (value) {
  return jspb.Message.setProto3IntField(this, 36, value)
}

/**
 * optional int32 marketPriceDigit = 37;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMarketpricedigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMarketpricedigit = function (value) {
  return jspb.Message.setProto3IntField(this, 37, value)
}

/**
 * optional int32 marginDigit = 38;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getMargindigit = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setMargindigit = function (value) {
  return jspb.Message.setProto3IntField(this, 38, value)
}

/**
 * optional int64 positionRiskRemind = 39;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getPositionriskremind = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 39, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setPositionriskremind = function (value) {
  return jspb.Message.setProto3IntField(this, 39, value)
}

/**
 * optional int32 sort = 40;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getSort = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setSort = function (value) {
  return jspb.Message.setProto3IntField(this, 40, value)
}

/**
 * optional int64 openTradeTime = 41;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getOpentradetime = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setOpentradetime = function (value) {
  return jspb.Message.setProto3IntField(this, 41, value)
}

/**
 * optional int64 feeAccount = 42;
 * @return {number}
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.getFeeaccount = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg.CurrencyPair} returns this
 */
proto.PositionHistoryPbMsg.CurrencyPair.prototype.setFeeaccount = function (value) {
  return jspb.Message.setProto3IntField(this, 42, value)
}

/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setId = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value)
}

/**
 * optional int64 userId = 2;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getUserid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setUserid = function (value) {
  return jspb.Message.setProto3IntField(this, 2, value)
}

/**
 * optional string openPrice = 3;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getOpenprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setOpenprice = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value)
}

/**
 * optional string closePrice = 4;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getCloseprice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setCloseprice = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value)
}

/**
 * optional string realizedSurplus = 5;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getRealizedsurplus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setRealizedsurplus = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value)
}

/**
 * optional string openMargin = 6;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getOpenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setOpenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value)
}

/**
 * optional string totalAmount = 7;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getTotalamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setTotalamount = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value)
}

/**
 * optional string closeAmount = 8;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getCloseamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setCloseamount = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value)
}

/**
 * optional string maxAmount = 9;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getMaxamount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setMaxamount = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value)
}

/**
 * optional int64 openDate = 10;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getOpendate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setOpendate = function (value) {
  return jspb.Message.setProto3IntField(this, 10, value)
}

/**
 * optional int64 closeAllDate = 11;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getClosealldate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setClosealldate = function (value) {
  return jspb.Message.setProto3IntField(this, 11, value)
}

/**
 * optional string contractCode = 12;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getContractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setContractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value)
}

/**
 * optional string detailSide = 13;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDetailside = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDetailside = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value)
}

/**
 * optional int32 dualPosition = 14;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getDualposition = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDualposition = function (value) {
  return jspb.Message.setProto3IntField(this, 14, value)
}

/**
 * optional int32 dealMarket = 15;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getDealmarket = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDealmarket = function (value) {
  return jspb.Message.setProto3IntField(this, 15, value)
}

/**
 * optional int32 lever = 16;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getLever = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setLever = function (value) {
  return jspb.Message.setProto3IntField(this, 16, value)
}

/**
 * optional int32 positionType = 17;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getPositiontype = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setPositiontype = function (value) {
  return jspb.Message.setProto3IntField(this, 17, value)
}

/**
 * optional int32 status = 18;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getStatus = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setStatus = function (value) {
  return jspb.Message.setProto3IntField(this, 18, value)
}

/**
 * optional int64 positionId = 19;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getPositionid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setPositionid = function (value) {
  return jspb.Message.setProto3IntField(this, 19, value)
}

/**
 * optional int32 env = 20;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getEnv = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setEnv = function (value) {
  return jspb.Message.setProto3IntField(this, 20, value)
}

/**
 * optional string baseContractCode = 21;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getBasecontractcode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setBasecontractcode = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value)
}

/**
 * optional int64 contractLiquidateDate = 22;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getContractliquidatedate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setContractliquidatedate = function (value) {
  return jspb.Message.setProto3IntField(this, 22, value)
}

/**
 * optional int32 brokerId = 23;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getBrokerid = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setBrokerid = function (value) {
  return jspb.Message.setProto3IntField(this, 23, value)
}

/**
 * optional string closeProfit = 24;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getCloseprofit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setCloseprofit = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value)
}

/**
 * optional string fundRateProfit = 25;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getFundrateprofit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setFundrateprofit = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value)
}

/**
 * optional string fee = 26;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getFee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setFee = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value)
}

/**
 * optional string deliveringProfit = 27;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDeliveringprofit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDeliveringprofit = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value)
}

/**
 * optional int32 selectedMode = 28;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getSelectedmode = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setSelectedmode = function (value) {
  return jspb.Message.setProto3IntField(this, 28, value)
}

/**
 * optional string bizType = 29;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getBiztype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setBiztype = function (value) {
  return jspb.Message.setProto3StringField(this, 29, value)
}

/**
 * optional string contractType = 30;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getContracttype = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setContracttype = function (value) {
  return jspb.Message.setProto3StringField(this, 30, value)
}

/**
 * optional int64 liquidationDate = 31;
 * @return {number}
 */
proto.PositionHistoryPbMsg.prototype.getLiquidationdate = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0))
}

/**
 * @param {number} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setLiquidationdate = function (value) {
  return jspb.Message.setProto3IntField(this, 31, value)
}

/**
 * optional CurrencyPair currencyPair = 32;
 * @return {?proto.PositionHistoryPbMsg.CurrencyPair}
 */
proto.PositionHistoryPbMsg.prototype.getCurrencypair = function () {
  return /** @type{?proto.PositionHistoryPbMsg.CurrencyPair} */ (
    jspb.Message.getWrapperField(this, proto.PositionHistoryPbMsg.CurrencyPair, 32)
  )
}

/**
 * @param {?proto.PositionHistoryPbMsg.CurrencyPair|undefined} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setCurrencypair = function (value) {
  return jspb.Message.setWrapperField(this, 32, value)
}

/**
 * Clears the message field making it undefined.
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.clearCurrencypair = function () {
  return this.setCurrencypair(undefined)
}

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PositionHistoryPbMsg.prototype.hasCurrencypair = function () {
  return jspb.Message.getField(this, 32) != null
}

/**
 * optional string donationFee = 33;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDonationfee = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDonationfee = function (value) {
  return jspb.Message.setProto3StringField(this, 33, value)
}

/**
 * optional string donationCloseProfit = 34;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDonationcloseprofit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDonationcloseprofit = function (value) {
  return jspb.Message.setProto3StringField(this, 34, value)
}

/**
 * optional string donationFundRateProfit = 35;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDonationfundrateprofit = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDonationfundrateprofit = function (value) {
  return jspb.Message.setProto3StringField(this, 35, value)
}

/**
 * optional string donationOpenMargin = 36;
 * @return {string}
 */
proto.PositionHistoryPbMsg.prototype.getDonationopenmargin = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ''))
}

/**
 * @param {string} value
 * @return {!proto.PositionHistoryPbMsg} returns this
 */
proto.PositionHistoryPbMsg.prototype.setDonationopenmargin = function (value) {
  return jspb.Message.setProto3StringField(this, 36, value)
}

goog.object.extend(exports, proto)
